<template>
  <div>
    <div>
      <v-card
        v-if="loading"
        class="grid ma-12"
        elevation="8"
        color="grey lighten-2"
        style="border-radius: 12px"
      >
        <Loader class="loading-page" />
      </v-card>
      <v-overlay v-if="errorMessage !== ''">
        <v-dialog v-model="error" max-width="550px" style="border-radius: 16px">
          <v-card scrollable>
            <div class="grid pt-12">
              <v-row>
                <v-card class="mr-5" style="border-radius: 12px">
                  <base-img
                    :src="require('@/assets/logos/icon1.svg')"
                    class="mx-auto pa-6"
                    contain
                    width="12"
                  />
                </v-card>
              </v-row>
              <v-divider></v-divider>
              <v-card-title class="text-body-2 text-center mt-4 text-wrap"
                >There was a problem getting your verification from Stitch.<br />
                Please try again later or use an alternative verification
                method.
                <br />
                If this problem persists please reach out to Strapp
                support.</v-card-title
              >

              <v-card-text class="text-caption text-center">
                ERROR MESSAGE: {{ errorMessage }}
              </v-card-text>

              <hr />
            </div>
            <v-card-actions class="mt-n6">
              <v-btn large color="accent darken-1" text @click="clearError()">
                Close
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-overlay>

      <div class="grid">
        <v-btn class="appbutton mt-12" v-if="error" to="/dashboard">
          Back to Dashboard
        </v-btn>
      </div>

      <v-col cols="12" lg="8" offset-lg="2">
        <v-card
          v-if="!loading && !error"
          class="grid"
          elevation="8"
          style="border-radius: 12px"
        >
          <v-row class="card-head grid mb-n2">
            <p v-if="verificationSuccess" class="text-h5 white--text mt-2">
              Booking accepted for {{ booking.itemName }}
            </p>
            <p
              v-else-if="paymentVerificationSuccess || paymentSuccess"
              class="text-md-h5 text-subtitle-1 white--text mt-2"
            >
              Payment for {{ booking.itemName }}
            </p>
            <p v-else class="text-h5 white--text mt-2">
              {{ booking.itemName }}
            </p>
          </v-row>

          <div v-if="paymentVerificationSuccess" class="grid text-center">
            <div
              border="bottom"
              outlined
              type="success"
              elevation="2"
              class="mt-10 text-subtitle-1 text-md-h6 app--text"
            >
              Your account was linked successfully and your verification data
              has been received. <br />
              You can now make the payment using your linked stitch account
              below! 🎉
            </div>
          </div>

          <div v-if="paymentSuccess" class="grid text-center">
            <div
              border="bottom"
              outlined
              type="success"
              elevation="2"
              class="mt-10 text-h6 app--text"
            >
              Your Payment was successful! 🎉
            </div>
          </div>

          <div v-if="verificationSuccess" class="text-center grid">
            <div
              border="bottom"
              outlined
              type="success"
              elevation="2"
              class="mt-10 text-h6 app--text"
            >
              Booking accepted your Verification was initiated! 🎉
            </div>
          </div>

          <v-row class="mt-9">
            <v-col class="grid" cols="8" offset="2">
              <v-btn
                v-if="paymentSuccess"
                block
                class="appbutton white--text mb-6 mx-8"
                to="/dashboard"
                @click="$router.push('/dashboard/?s=3')"
                >Continue 👉</v-btn
              >

              <v-btn
                v-if="verificationSuccess"
                block
                class="appbutton white--text mb-6 mx-8"
                to="/dashboard"
                @click="$router.push('/dashboard/?s=2')"
                >Continue 👉</v-btn
              >

              <v-btn
                v-else-if="
                  !paymentSuccess &&
                  !paymentVerificationSuccess &&
                  !verificationSuccess
                "
                block
                class="appbutton white--text mb-6 mx-8"
                to="/dashboard"
                @click="$router.push('/dashboard/?s=2')"
                >Continue 👉</v-btn
              >
            </v-col>
          </v-row>

          <Loader class="loading-page" v-if="loading" />

          <div v-else-if="paymentSuccess && !loading" class="grid text-left">
            <v-col cols="10" md="8" lg="8">
              <p class="text-h6 app--text">What happens next?</p>

              <p class="text-subtitle-1 primary--text font-weight-bold">
                1. Approval
              </p>
              <p>
                We have recieved your payment. We will send you the lenders
                contact details once it has been approved.
              </p>

              <p class="font-italic">
                payment approval can take up to 24 hours.
              </p>

              <p class="text-subtitle-1 primary--text font-weight-bold">
                2. Contact the lender to arrange pickup or dropoff
              </p>

              <p>
                Once we have approved your payment, we will send you the lenders
                contact details so you can arrange pickup or dropoff.
              </p>

              <p class="font-italic">
                Keep your eyes on your email inbox, this is how we give you
                updates on your booking.
              </p>

              <!-- <p>
                Borrower responsibility: Borrowers are fully responsible for for
                rented items in their possession, and liable to pay for non
                return or damages.
              </p> -->
            </v-col>
          </div>

          <div
            v-else-if="paymentVerificationSuccess && !loading"
            class="grid text-left"
          >
            <v-row>
              <v-btn
                elevation="6"
                large
                block
                class="ml-n3 ma-1 mb-4 appbutton rounded-lg white--text font-weight-medium"
                color="#B22AF0"
                z-index="12"
                @click="pay()"
                :loading="payloading"
              >
                <base-img
                  :src="require('@/assets/logos/icon1.svg')"
                  contain
                  max-height="35"
                  max-width="35"
                />
                Pay R
                <span>{{ this.booking.total }}</span>
              </v-btn>
            </v-row>

            <v-col cols="12">
              <v-row class="">
                <status-image
                  :booking="booking"
                  :lenderView="lenderView"
                  :borrowerView="borrowerView"
                ></status-image>
                <v-col
                  v-if="paymentSuccess || paymentVerificationSuccess"
                  class="mb-n4"
                >
                  <borrower-view-dto :booking="booking"></borrower-view-dto>
                </v-col>

                <v-col v-if="verificationSuccess" class="mb-n4">
                  <lender-view-dto :booking="booking"></lender-view-dto>
                </v-col>
              </v-row>
            </v-col>

            <v-col cols="10" md="8" lg="8">
              <p class="text-h6 app--text">What happens next?</p>

              <p class="text-subtitle-1 primary--text font-weight-bold">
                1. Approval
              </p>
              <p>
                We have recieved your verification. We will send you the lenders
                contact details once it has been approved.
              </p>

              <p class="font-italic">
                Verification approval can take up to 24 hours.
              </p>

              <p class="text-subtitle-1 primary--text font-weight-bold">
                2. Contact the lender to arrange pickup or dropoff
              </p>

              <p>
                Once we have approved your verification, we will send you the
                lenders contact details so you can arrange pickup or dropoff.
              </p>

              <p class="font-italic">
                Keep your eyes on your email inbox, this is how we give you
                updates on your booking.
              </p>

              <!-- <p>
                Borrower responsibility: Borrowers are fully responsible for for
                rented items in their possession, and liable to pay for non
                return or damages.
              </p> -->
            </v-col>
          </div>

          <div
            v-else-if="verificationSuccess && !loading"
            class="grid text-left"
          >
            <v-col cols="10" md="8" lg="8">
              <p class="text-h6 app--text">What happens next?</p>

              <p class="text-subtitle-1 primary--text font-weight-bold">
                1. Approval
              </p>
              <p>
                We have recieved your verification. We will send you the
                borrowers contact details once it has been approved.
              </p>

              <p class="font-italic">
                Verification approval can take up to 24 hours.
              </p>

              <p class="text-subtitle-1 primary--text font-weight-bold">
                2. Contact the borrower to arrange pickup or dropoff
              </p>

              <p>
                Once we have approved your verification, we will send you the
                lenders contact details so you can arrange pickup or dropoff.
              </p>

              <p class="font-italic">
                Keep your eyes on your email inbox, this is how we give you
                updates on your booking.
              </p>

              <p class="text-subtitle-1 primary--text font-weight-bold">
                2. Upload proof of life images
              </p>

              <p>
                You will be notified by email before your item goes out to
                upload proof of life images. These images are used to determine
                the state of the item before it is handed over. This is to
                confirm its current functional state so that if there is any
                damage to an item, we have some images to compare it back to.
              </p>
            </v-col>
          </div>

          <!-- <v-col cols="12" md="8">
            <v-divider></v-divider>

            <div class="grid mt-5">
              <h2>FAQ</h2>
            </div>

            <v-expansion-panels
              v-if="verificationSuccess"
              multiple
              class="mt-6 mb-4"
            >
              <v-expansion-panel>
                <v-expansion-panel-header
                  class="text-subtitle-1 text-md-h5 secondary--text font-weight-bold"
                >
                  How does delivery work?
                </v-expansion-panel-header>
                <v-expansion-panel-content class="text-caption primary--text">
                  Delivery is decided between the lender and the borrower. A
                  mutual agreement should be decided on who should pick up and
                  return the item to each other. All delivery charges must be
                  indicated in the listing and included in the rental fee and
                  should not be an additional cost.<br /><br />
                 A seamless, secure payments experience as convenient as card.
                  Users add their preferred bank account through Stitch SafeLink
                  once, and pay securely with just one click every time after.
                  <br /><br />
                  to. With LinkPay, you can link your account outside of a
                  payments flow and come back later to easily make payments any
                  time they need -->
          <!-- </v-expansion-panel-content>
              </v-expansion-panel>
              <v-expansion-panel>
                <v-expansion-panel-header
                  class="text-subtitle-1 text-md-h5 secondary--text font-weight-bold"
                >
                  How do rating and reviews work?
                </v-expansion-panel-header>
                <v-expansion-panel-content class="text-caption primary--text">
                  After each booking has been completed, we ask both the
                  borrower and lender to complete a rating and review of each of
                  their experiences with the item and the corresponding person.
                  These rating and reviews are important for your profile as
                  well as the item. Rating and reviews are stored on your
                  profile as well as the actual item.
                </v-expansion-panel-content>
              </v-expansion-panel>
              <v-expansion-panel>
                <v-expansion-panel-header
                  class="text-subtitle-1 text-md-h5 secondary--text font-weight-bold"
                >
                  When do I receive my rental fee from Strapp for my rental?
                </v-expansion-panel-header>
                <v-expansion-panel-content class="text-caption primary--text">
                  Once the booking has been finalised and we have received
                  payment from the borrower, we wait until we receive
                  confirmation that the borrower has collected the item. Once we
                  have received this confirmation, we then payout the rental fee
                  to the item owner within 24 hours from the start of the
                  booking.
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>

            <v-expansion-panels
              v-if="paymentSuccess || paymentVerificationSuccess"
              multiple
              class="mt-6 mb-4"
            >
              <v-expansion-panel>
                <v-expansion-panel-header
                  class="text-subtitle-1 text-md-h5 secondary--text font-weight-bold"
                >
                  How does delivery work?
                </v-expansion-panel-header>
                <v-expansion-panel-content class="text-caption primary--text">
                  Delivery is decided between the lender and the borrower. A
                  mutual agreement should be decided on who should pick up and
                  return the item to each other. All delivery charges must be
                  indicated in the listing and included in the rental fee and
                  should not be an additional cost.<br /><br />
                </v-expansion-panel-content>
              </v-expansion-panel>
              <v-expansion-panel>
                <v-expansion-panel-header
                  class="text-subtitle-1 text-md-h5 secondary--text font-weight-bold"
                >
                  Can i cancel the booking after receiving the item?
                </v-expansion-panel-header>
                <v-expansion-panel-content class="text-caption primary--text">
                  If the borrower cancels after they have picked up the item,
                  there will be a 30% cancellation fee and they will receive a
                  70% refund of the rental fees for any remaining nights and the
                  Strapp service fee will not be refunded. However, they will
                  still pay for any days spent.
                </v-expansion-panel-content>
              </v-expansion-panel>
              <v-expansion-panel>
                <v-expansion-panel-header
                  class="text-subtitle-1 text-md-h5 secondary--text font-weight-bold"
                >
                  How do rating and reviews work?
                </v-expansion-panel-header>
                <v-expansion-panel-content class="text-caption primary--text">
                  After each booking has been completed, we ask both the
                  borrower and lender to complete a rating and review of each of
                  their experiences with the item and the corresponding person.
                  These rating and reviews are important for your profile as
                  well as the item. Rating and reviews are stored on your
                  profile as well as the actual item.
                </v-expansion-panel-content>
              </v-expansion-panel>
              <v-expansion-panel>
                <v-expansion-panel-header
                  class="text-subtitle-1 text-md-h5 secondary--text font-weight-bold"
                >
                  What time do i need to return the item?
                </v-expansion-panel-header>
                <v-expansion-panel-content class="text-caption primary--text">
                  One day's rental is counted a 24 hour period from the time you
                  picked up the item. That means if you rented an item for one
                  day and picked it up at 10am Monday, the default is that the
                  item would be due back on 10am Tuesday - unless you and lender
                  have agreed in writing to an alternative time. It's important
                  that you return the items on time as many of our lenders have
                  back to back rentals. Lenders are entitled to request late
                  fees should you return the items after the return time.
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>
          </v-col>  -->
        </v-card></v-col
      >
    </div>

    <div v-if="(success = false)" height="100vh" class="text-center grid">
      <v-img
        contain
        :src="require('@/assets/fontawesome/xmark-to-slot-duotone.svg')"
      ></v-img>
      <h1>PAYMENT UNSUCCESFUL</h1>
      <br />
      <p>
        We are sorrry but there was a problem in processing your payment.Please
        try again
      </p>

      <v-row class="mt-8">
        <v-btn class="appbutton" color="accent" @click="Query()"
          >TRY AGAIN</v-btn
        >
      </v-row>
    </div>
  </div>
</template>

<script>
// import { GET_ACCOUNTS } from "../queries";
import gql from 'graphql-tag';
const { GraphQLClient } = require('graphql-request');
import firebase from 'firebase/compat/app';
import {
  connectFirestoreEmulator,
  doc,
  getDoc,
  getFirestore,
  getDocs,
  docSnap,
  updateDoc,
  serverTimestamp,
  collection,
  where,
  query,
} from 'firebase/firestore';
import {
  getFunctions,
  httpsCallable,
  connectFunctionsEmulator,
} from 'firebase/functions';
import { TokenKind } from 'graphql';
import { store } from '../store';

export default {
  name: 'StrappReturn',

  data: () => ({
    skipQuery: true,
    code: '',
    status: '',
    verifier: '',
    // success: '',
    headers: '',
    paymentInitiationId: '',
    token: '',
    errorMessage: '',
    // loading: false,
    paymentAmount: null,
    booking: [],
    error: false,
    borrowerView: false,
    lenderView: false,
    verificationSuccess: false,
    paymentSuccess: false,
    paymentVerificationSuccess: false,
    loading: true,
    payloading: false,
  }),

  components: {
    Loader: () => import('@/components/loaders/stitchReturnLoader.vue'),
    LenderViewDto: () => import('@/components/booking/lenderViewDTO.vue'),
    BorrowerViewDto: () => import('@/components/booking/borrowerViewDTO.vue'),
    StatusImage: () => import('@/components/booking/statusImage.vue'),
    BookingHeader: () => import('@/components/booking/bookingHeader.vue'),
  },
  computed: {},

  async created() {
    this.Query();
  },

  methods: {
    clearError() {
      this.error = false;
      this.$store.dispatch('clearError');
      this.$store.commit('clearError');
      this.errorMessage = '';
      //route to dashboard
      this.$router.push('/dashboard');
    },
    pay() {
      this.$store.commit('setLoading', true);

      this.payloading = true;

      const functions = getFunctions();

      const createPayment = httpsCallable(functions, 'createPayment');

      createPayment({
        userId: this.$store.state.user.id,
        email: this.$store.state.user.email,
        booking: this.booking,
        bookingId: this.booking.id,
        state: this.state,
      })
        .then((result) => {
          // Read result of the Cloud Function.
          /** @type {any} */
          const data = result.data;
          console.log('data', data);

          if (data.result == 'success') {
            this.$router.push(
              '/return' + '?status=complete' + '&bid=' + this.booking.id
            );
          } else if (data.result == 'multi') {
            window.location.replace(data.url, '_self');
          } else if (data.result == 'error') {
            this.errorMessage = 'Error: Could not create new linking URL';
            this.$emit('erorr', this.errorMessage);
          }

          this.$store.commit('setLoading', false);
        })
        .catch((error) => {
          console.log('error', error);
          this.errorMessage = 'Error: Could not process payment';
          this.$emit('erorr', this.errorMessage);
          //set Error in store
          this.$store.commit('setError', this.errorMessage);
          this.$store.commit('setLoading', false);
        });
    },
    onClose() {
      this.errorMessage = '';
    },
    async Query() {
      // this.$router.push({
      //   path: '/dashboard',
      //   params: { title: 'bookings-placed' },
      // });

      // this.$store.dispatch("loadUserBookings",  this.$store.getters.user.id);
      //  this.$store.dispatch("loadBookings");

      this.loading = true;

      const code = this.$route.query.code;
      console.log('code:', code);

      const state = this.$route.query.state;
      console.log('state:', state);

      const id = this.$route.query.id;
      console.log('id:', id);

      const bid = this.$route.query.bid;
      console.log('bid:', bid);

      // create a payment object

      console.log('status:', this.$route.query.status);

      if (id !== undefined && bid == undefined) {
        console.log('multi', id);

        this.borrowerView = true;

        const db = getFirestore();

        // connectFirestoreEmulator(db, 'localhost', 8081);

        // get booking where state = state
        const querySnapshot = await getDocs(
          query(
            collection(db, 'bookings'),
            where('state', '==', this.$route.query.state)
          )
        );

        querySnapshot.forEach(async (docSnapshot) => {
          // doc.data() is never undefined for query doc snapshots
          console.log(docSnapshot.id, ' => ', docSnapshot.data());
          this.booking = docSnapshot.data();
          this.booking.id = docSnapshot.id;

          const verifRef = doc(db, 'bookings', this.booking.id);
          await updateDoc(verifRef, {
            status: 'awaiting-images',
            paymentInitiatedAt: new Date(),
          }).then(() => {
            console.log('Document successfully updated!');
            this.paymentSuccess = true;
            this.loading = false;
          });
        });

        // if (docSnap.exists()) {
        //   console.log('Document data:', docSnap.data());
        //   this.booking = docSnap.data();

        //   this.$store.commit('setPaymentSuccess', true);
        //   this.$store.commit('setLoading', false);
        // } else {
        //   // doc.data() will be undefined in this case
        //   console.log('No such document!');
        //   this.errorMessage = "We can't find that booking! :(";
        // }

        console.log('booking', this.booking);
      }

      if (bid !== undefined) {
        const status = this.$route.query.status;
        console.log('straight', status);
        console.log('booking id', this.$route.query.bid);

        const bid = this.$route.query.bid;

        //get booking and set booking to the
        const db = getFirestore();

        // connectFirestoreEmulator(db, 'localhost', 8081);

        const docSnap = await getDoc(doc(db, 'bookings', bid));

        if (docSnap.exists()) {
          console.log('Document data:', docSnap.data());
          this.booking = docSnap.data();
        } else {
          // doc.data() will be undefined in this case
          console.log('No such document!');
          this.errorMessage = "We can't find that booking! :(";
        }

        this.borrowerView = true;

        this.$store
          .dispatch('updateBookingData', {
            id: bid,
            status: 'awaiting-images',
          })
          .then(() => {
            // this.paymentSuccess = true;
            this.loading = false;
          });

        //set payment success to true
        this.paymentSuccess = true;
        this.$store.commit('setLoading', false);
      } else if (code !== undefined && state !== undefined) {
        const state = this.$route.query.state;
        console.log('state and code:', state);

        const db = getFirestore();

        // connectFirestoreEmulator(db, 'localhost', 8081);

        // get booking where state = state
        const querySnapshot = await getDocs(
          query(collection(db, 'bookings'), where('state', '==', state))
        );

        querySnapshot.forEach((docSnapshot) => {
          // doc.data() is never undefined for query doc snapshots
          console.log(docSnapshot.id, ' => ', docSnapshot.data());
          this.booking = docSnapshot.data();
          this.booking.id = docSnapshot.id;
        });

        const functions = getFunctions();

        // connectFunctionsEmulator(functions, 'localhost', 5001);

        const getVerificationData = httpsCallable(
          functions,
          'getVerificationData'
        );

        this.$store.commit('setLoading', true);

        getVerificationData({
          userId: this.$store.state.user.id,
          refreshToken: this.$store.state.user.refreshToken,
          booking: this.booking,
          verifier: this.booking.verifier,
          code: code,
        }).then((result) => {
          // Read result of the Cloud Function.
          /** @type {any} */
          const data = result.data;
          console.log('data', data);
          console.log('returnTYPE', data.returnType);
          this.$store.commit('setLoading', false);

          if (data === 'PaymentVerificationSuccess') {
            console.log('   this.paymentVerificationSuccess = true;');

            // const user = this.$store.state.user;
            // user.stitch_verification_received = true;
            // this.$store.commit('setUser', user);
            this.loading = false;
            this.paymentVerificationSuccess = true;
            this.payloading = false;

            // this.$store
            //   .dispatch('updateBookingData', {
            //     id: this.booking.id,
            //     status: 'awaiting-payment',
            //   })
            //   .then(() => {
            //
            //   });
          } else if (data === 'PaymentVerificationFailed') {
            this.paymentVerificationFailed = true;
          } else if (data === null) {
            this.paymentVerificationError = true;
          } else if (data === 'setVerificationSuccess') {
            this.$store.commit('setLoading', false);

            const user = this.$store.state.user;
            user.manual_verification_received = true;
            this.$store.commit('setUser', user);

            this.$store
              .dispatch('updateBookingData', {
                id: this.booking.id,
                status: 'awaiting-payment',
              })
              .then(() => {
                this.verificationSuccess = true;
                this.loading = false;
              });
          } else if (data.returnType == 'error') {
            //setLoading to false
            console.log('returnType == eroor');
            this.loading = false;
            this.errorMessage =
              'Something went wrong with getting your verification data! Please try an alternative verification method or reach out to Strapp support for assistance.';
            this.error = true;
          }
        });

        return;
      } else if (state !== undefined) {
        const state = this.$route.query.state;
        console.log('state only:', state);

        const db = getFirestore();

        // connectFirestoreEmulator(db, 'localhost', 8081);

        // get booking where state = state
        const querySnapshot = await getDocs(
          query(collection(db, 'bookings'), where('state', '==', state))
        );

        querySnapshot.forEach((docSnapshot) => {
          // doc.data() is never undefined for query doc snapshots
          console.log(docSnapshot.id, ' => ', docSnapshot.data());
          this.booking = docSnapshot.data();
          this.booking.id = docSnapshot.id;
        });

        const functions = getFunctions();

        // connectFunctionsEmulator(functions, 'localhost', 5001);

        const getVerificationData = httpsCallable(
          functions,
          'getVerificationData'
        );

        this.$store.commit('setLoading', true);

        getVerificationData({
          userId: this.$store.state.user.id,
          refreshToken: this.$store.state.user.refreshToken,
          booking: this.booking,
          verifier: this.booking.verifier,
          code: code,
        }).then((result) => {
          // Read result of the Cloud Function.
          /** @type {any} */
          const data = result.data;
          console.log('data', data);

          if (data.returnType == 'error') {
            this.error = true;
            this.errorMessage =
              'Something went wrong with getting your verification data! Please try an alternative verification method or reach out to Strapp support for assistance.';
            this.loading = false;
          }
          if (data == 'PaymentVerificationSuccess') {
            // update booking status to awaiting-images

            this.loading = false;
            this.payloading = false;
            // this.$store.dispatch('updateBookingData', {
            //   id: this.booking.id,
            //   status: 'awaiting-images',
            // });

            this.paymentVerificationSuccess = true;
          } else if (data == 'PaymentVerificationFailed') {
            this.paymentVerificationFailed = true;
          } else if (data == null) {
            this.paymentVerificationError = true;
          } else if (data == 'setVerificationSuccess') {
            this.$store.commit('setLoading', false);

            this.$store
              .dispatch('updateBookingData', {
                id: this.booking.id,
                status: 'awaiting-payment',
              })
              .then(() => {
                this.verificationSuccess = true;
                this.loading = false;
              });
          } else if (data == 'error') {
            //setLoading to false
            this.loading = false;
            this.errorMessage = 'Something went wrong! :(';
            this.error = true;
          }
        });

        return;
      } else if (bid === undefined && code === undefined && id === undefined) {
        this.error = true;
        this.errorMessage =
          'Something went wrong with the payment process! Please try again';
        this.loading = false;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.card-head {
  background-color: #b22af0;
  width: 100%;
  padding: 14px;
}

.type3 {
  width: 50px;
  height: 50px;
  border: 3px solid #b22af0;
}
</style>
